import { kemsuWebServer } from "~/shared/config"

/**
 * Формирует url страницы системы на KemsuWeb
 * @param path путь
 * @param searchParams объект, который содержит search-параметры
 * @param https использовать https
 * @param server имя сервера
 * @example
 * import {createKemsuWebSystemPageUrl} from '~/shared/api/kemsuweb';
 *
 * // вернет 'https://xiais.kemsu.ru/test/path.htm?param1=value&param2=42'
 * const url = createKemsuWebSystemPageUrl('test/path.htm', { param1: "value", param2: 42 });
 *
 */
export function createKemsuWebSystemPageUrl(
	path: string,
	searchParams: { [k: string]: string | number } = {},
	https = true,
	server = kemsuWebServer,
) {
	searchParams = { ...searchParams, backToNewEios: location.toString() }

	const searchStr = Object.keys(searchParams)
		.map((key) => (searchParams[key] ? `${key}=${searchParams[key]}` : key))
		.join("&")
	return `${https ? "https" : "http"}://${server}.kemsu.ru/${path}?${searchStr}`
}
